'use client';

import { ExpressiveAnchorButton } from '../../expressive-button/expressive-anchor-button';
import { HeaderLoginButton } from '../../navigation/HeaderRedesignLoginButton';
import { breakpoints } from '@thrivent/midwest-shared';
import styled, { keyframes } from 'styled-components';

export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
`;

export const NavIconMenu = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: 0.875rem;
  font-weight: 400;
  color: ${(p) =>
    p.theme.midwestColors.componentButtonColorBackgroundStrongPrimaryDefault};
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 1rem;
  gap: 0.5rem;

  svg {
    fill: ${(p) =>
      p.theme.midwestColors.componentButtonColorBackgroundStrongPrimaryDefault};
    display: block;
    width: 32px;
    height: 32px;
  }
`;

export const NavIconClose = styled.button`
  padding-right: 0px;
  display: flex;
  flex-direction: row;
  background: transparent;
  border: none;
  cursor: pointer;
  padding-top: 1rem;
  padding-bottom: 1rem;
  gap: 0.5rem;

  svg {
    margin-top: 2px;
    fill: ${(p) => p.theme.midwestColors.sentimentNegativeStrong};
    display: block;
    width: 24px;
    height: 24px;
  }
`;

export const MenuHeader = styled.div`
  position: sticky;
  top: 0;
  background: ${(p) => p.theme.midwestColors.white};
  width: 100%;
  padding: 0.375rem 1rem;

  display: flex;
  justify-content: space-between;
`;

const slideInFromRight = keyframes`
    from {
        transform: translateX(100%);
    }
    to {
        transform: translateX(0);
    }
`;

const slideInFromLeft = keyframes`
    from {
        transform: translateX(-100%);
    }
    to {
        transform: translateX(0);
    }
`;

export const MenuBodySecondary = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 1rem;
  animation: ${slideInFromRight} 0.2s ease-in-out;
`;

export const MenuBodyMain = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 1rem;
  animation: ${slideInFromLeft} 0.2s ease-in-out;
`;

export const Spacer = styled.div`
  width: 100%;
  height: 11rem;
`;

export const MenuFooter = styled.div`
  width: 100%;
  background: ${(p) => p.theme.midwestColors.white};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1rem;
  padding: 2rem;
  box-shadow: 0 -8px 8px #f0f0f0;

  button {
    display: block;
    flex: 1;
  }
`;

export const NavListItem = styled.nav`
  font-family: ${(p) => p.theme.font.primary};
  color: ${(p) => p.theme.midwestColors.componentButtonColorTextSubtlePrimary};

  background: transparent;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 1px solid
    ${(p) => p.theme.midwestColors.identityBrandPrimaryWeak};

  padding-block: 1rem;

  &:hover,
  &:focus {
    text-decoration: none;
  }
`;

export const NavTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const NavTitle = styled.div`
  color: ${(p) =>
    p.theme.midwestColors.componentButtonColorBackgroundStrongPrimaryDefault};
  font-size: 1.125rem;
  font-weight: 400;
`;

export const NavSubTitle = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  font-size: 0.875rem;
  font-weight: 400;
  color: ${(p) => p.theme.midwestColors.semanticColorSentimentInfoDense};
`;

export const Menu = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;

  @supports (height: 100dvh) {
    height: 100dvh;
  }

  background: ${(p) => p.theme.midwestColors.white};
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  text-align: left;
  z-index: 1000;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 1rem;
`;

export const BackButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 0.875rem;
  font-weight: 400;

  svg {
    transform: rotate(180deg) scale(0.75);
  }
`;

export const MainButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
`;

export const TopLeftClickable = styled.button`
  font-size: 0.875rem;
  font-weight: 400;
  padding-left: 0px;
  color: ${(p) =>
    p.theme.midwestColors.componentButtonColorBackgroundStrongPrimaryDefault};
  background: transparent;
  border: none;
  cursor: pointer;
`;

export const LoginButtonContainer = styled.div`
  max-width: 5rem;
  ${breakpoints.desktop} {
    display: none;
  }
`;

export const LoginButton = styled(HeaderLoginButton)`
  && {
    width: 100%;
  }
`;

export const AdvisorButton = styled(ExpressiveAnchorButton)`
  && {
    width: 100%;
  }
`;
